import React from "react";
import PictureProvider from "../../components/Picture";
import { PictureData } from "../../../types/PictureData";
import { IDynamicBlockComponent } from "../../dynamicPageBuilder/IDynamicBlockComponent";

export type ModeItem = {
  lead: string;
  header: string;
  mediaId: PictureData;
};

const Modes: React.FunctionComponent<IDynamicBlockComponent> = ({
  blockData,
}): React.ReactElement => {
  const {
    data: { element, background = "" },
  } = blockData as Record<string, Record<string, unknown>>;

  const items: Array<ModeItem> = Object.values(
    element as Record<string, ModeItem>
  );

  return (
    <div
      className={`modes ${background === "grey" ? "mainBackgroundGrey" : ""}`}
    >
      <div className="modes__container desktop-container">
        {items.map((item, index) => (
          <div className="modes__bigCard" key={index}>
            {item.mediaId && item.mediaId.publicUrl && (
              <PictureProvider
                data={item.mediaId}
                className="modes__bigCard__img"
              />
            )}

            <h3 className="modes__bigCard__header">{item.header}</h3>
            <div
              className="modes__bigCard__content"
              dangerouslySetInnerHTML={{ __html: item.lead }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Modes;
